<template>
<div>
  <el-upload
      id="data_file"
      drag
      :on-success="start"
      action="/api/uploads">
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
  </el-upload>
  <div><em>Only the first million rows will be compared. Contact us if you need to compare more rows.</em></div>
  <div v-if="inError" style="margin:10px;background-color:pink">{{error_message}}</div>
  <div v-else-if="submitted" style="margin:10px;background-color:lightgoldenrodyellow">Submitted new data file.</div>
  <div v-if="dateOfData" style="margin-top:15px;padding:10px;background-color:darkgray;color:white;">Showing data from file uploaded at <strong>{{dateOfData}}</strong>. You can upload data above in order to compare another file. If you upload, you need to refresh this page until you see the new timestamp.</div>
  <el-table
      :data="tableData"
      style="width: 100%">
    <el-table-column
      prop="row_num"
      label=""
      width="100">

    </el-table-column>
    <el-table-column
        prop="url"
        label="URL"
        show-overflow-tooltip
    >
    </el-table-column>
    <el-table-column
        prop="status"
        label="Status"
        :filters="[
          { text: 'in DB', value: 'in DB' },
          { text: 'dupe in DB', value: 'dupe in DB' },
          { text: 'never encountered', value: 'never encountered' },
          { text: 'encountered in previous import', value: 'encountered in previous import' },
          { text: 'failed crawl request', value: 'failed crawl request' },
          { text: 'redirect', value: 'redirect' },
        ]"
        :filter-method="filterStatus"
        filter-placement="bottom-end"
    >
    </el-table-column>
    <el-table-column
        prop="text"
        label="Info"
        show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.hasOwnProperty('link') && scope.row.link !== ''">
          <a :href="scope.row.link" target="_blank">{{scope.row.text}}</a>
        </span>
        <span v-else>
                {{scope.row.text}}
        </span>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>

<script>
export default {
  name: "ListCompare",
  props: ['extent_id_from_blade'],
  data() {
    return {
      tableData: [],
      inError: false,
      error_code: null,
      dateOfData: null,
      submitted: false,
    }
  },
  mounted() {
    console.log('holler!')
    let url = '/list_compare_data/' + this.extent_id_from_blade
    console.log(url)
    axios.get(url)
        .then(response => {
          console.log(response)
          this.tableData = response.data.rows
          this.dateOfData = response.data.timestamp
        })
        .catch(error => {
          console.log('could not load map')
        })
  },
  methods: {
    start(response) {
      this.inError = false
      this.submitted = false
      axios.post('/list_compare/' + this.extent_id_from_blade, {
        upload_file: response
      }).then(response => {
        this.inError = false
        this.submitted = true
        console.log(response)
      }).catch(error => {
        this.inError = true
        this.error_code = error.response.status
        console.log('oops problem starting import')
        console.log(error.response)
      })
      //
    },
    filterStatus(value, row) {
      return row.status === value
    },
  },
  computed: {
    error_message: function () {
      if (this.inError) {
        if (this.error_code===504) {
          return "Timed out request, but just to see if the CSV is complete"
        } else {
          return "Error in Processing"
        }
      } else {
        return ""
      }
    },
  },
}
</script>

<style scoped>

</style>